export default "__VITE_ASSET__Cgw1rNyK__"